import { useState, useEffect } from 'react';
import FooterLogin from '../FooterLogin/FooterLogin';
import styles from './login.module.css';
import CelcomLogo from '../../public/resources/logo/logo-celcom-business-reverse_dark.svg';
import Registration from './Registration';
import LoadingDailog from '../../Helper/LoadingDailog';
import LoginComponent from './Login';
import Footer from '../Layout/footer';
import { NEXT_API_URL } from '../../Helper/Config';
import { msalInstance1 } from '../../services/msal';
import { useDidMountEffect } from '../../Helper/helper';
import LoadingForComponent from '../ReusableComponents/Loading/LoadingForComponent';

function Main({ adminToken, setAdminToken, screenName, setScreenName }) {
  const [bufferImg, setBufferImg] = useState('');
  const [title, setTitle] = useState('');
  const [noShow, setNoshow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [noData, setNoData] = useState('');
  const [imageName, setImageName] = useState("");

  const fetchImageBanner = async () => {
    setIsLoading(true);
    let response = await fetch(`/bizcareui/api/updatePromotion`, {
      method: 'GET',
    });
    let { result } = await response.json();
    console.log(result);
    if (result === 'Failed to load data') {
      setIsLoading(false);
      setNoData('Please check your Connection!');
    } else if (result === 'No Data Found') {
      setIsLoading(false);
      setNoData('No Images Found');
    } else {
      setIsLoading(false);
      setBufferImg(Buffer.from(result[0]?.IMAGE_FILE_CONTENT, 'base64'));
      setTitle(result[0]?.TITLE);
      setImageName(result[0]?.IMAGE_NAME);
    }
  };

  useEffect(() => {
    fetchImageBanner();
    if (
      screenName === 'login' &&
      window.sessionStorage.getItem('loginType') != 'AD'
    ) {
      setNoshow(true);
    } else {
      msalInstance1
        .handleRedirectPromise()
        .then(async (res) => {
          if (res != null && res.account != null) {
            msalInstance1.setActiveAccount(res.account);
            if (res.idToken) {
              setScreenName(null);
              setNoshow(false);
              console.log('id token for AD', res.idToken);
              setAdminToken(res.idToken);
              window.location.href = `${NEXT_API_URL}/bizcareui/api/auth/authAdmin?id_token=${res.idToken}`;
            }
          }
        })
        .catch((err) => {
          dispatch(LogoutUserState());
          window.sessionStorage.setItem('loginType', '');
          console.log(err);
        });

      setNoshow(false);
    }
  }, [adminToken]);
  useDidMountEffect(() => {
    setNoshow(true);
  }, [window.sessionStorage.getItem('loginType') !== 'AD']);
  const ShowSelectionContent = () => {
    if (screenName === 'login') {
      if (adminToken === '' && !msalInstance1.getActiveAccount()) {
        setNoshow(true);
        return (
          <LoginComponent
            setScreenName={setScreenName}
            adminToken={adminToken}
            setAdminToken={setAdminToken}
            screenName={screenName}
            setNoshow={setNoshow}
            noShow={noShow}
          />
        );
      } else return <LoadingDailog />;
    } else if (msalInstance1.getActiveAccount() && adminToken != '') {
      window.location.href = `${NEXT_API_URL}/bizcareui/api/auth/authAdmin?id_token=${adminToken}`;
    } else if (screenName === 'registration') {
      return <Registration setScreenName={setScreenName} />;
    }
  };
  
  const getMimeType = (name) => {
  if (!name) return "jpeg";
  const ext = name.split(".").pop().toLowerCase();
 
  console.log("ext",ext);
 
  if (["jpg", "jpeg"].includes(ext)) return "jpeg";
  if (ext === "png") return "png";
  if (ext === "gif") return "gif";
  if (ext === "tiff") return "tiff";
 
  return "jpeg";
};
 
const mimeType = getMimeType(imageName); // ideally from IMAGE_NAME
 
console.log("title",title);
console.log("bufferImg",imageName);
  return (
    <>
      {noShow && window.sessionStorage.getItem('loginType') !== 'AD' && (
        <div className={styles.pageContainerLogin}>
          {/* <LoadingDailog isLoading={isLoading}></LoadingDailog> */}
          <div className={styles.row}>
          {noData ? (
              <div className={styles.buildingSectionNoData}>{noData}</div>
            ) : (
              <div className={styles.buildingSection2}>
                <img
                  src={`data:image/${mimeType};base64,${bufferImg}`}
                  alt="banner_image"
                  className={`${styles.buildingSection} img-fluid`}
                  title={title}
                />
                <LoadingForComponent isLoading={isLoading} login={true} />

                {/* <div className={styles.textNote}>
                  <span className="font-weight-bold">*Note: </span>This is a
                  dummy image for reference purpose only.
                </div> */}
              </div>
            )}

            <div className={styles.formSection}>
              <div
                className={
                  screenName === 'registration' ? '' : `${styles.contentLogin}`
                }
              >
                <div className={styles.contents}>
                  <div
                    className={
                      screenName === 'registration' ? '' : `${styles.contentUp}`
                    }
                  >
                    {screenName === 'registration' ? null : (
                      <div className={styles.celcomLogo}>
                        <CelcomLogo className={styles.celcom} />
                      </div>
                    )}
                    <ShowSelectionContent />
                  </div>
                  {screenName === 'registration' ? null : <FooterLogin />}
                </div>
              </div>
            </div>
          </div>
          {screenName === 'login' && <Footer />}
          {screenName === 'registration' && <Footer />}
        </div>
      )}
    </>
  );
}

export default Main;